/**
 * @author xyguo
 * @description 
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool } from '@/tool'
import 'antd/dist/antd.css';
import { Row, Col ,Input} from 'antd';
const { TextArea } = Input;
let { WizContainer, WizReduxTemplatem, modelUtils } = framework_tool;
import { ExportExcel } from '@/components/index'
let { WizCard, WizLayout, WizIcon,WizSpin,WizTypography } = component_tool;
const { Paragraph } = WizTypography;

import cx from 'classnames';
class NormalDealerImport extends WizContainer {

  componentName = 'NormalDealerImport';

  constructor(props) {
    super(props);
    this.state = {
      name: null,
    }
  }


  _handldImport(nextProps, nextState) {
    let o = nextProps['normalDealerImports']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      this.props.changeModal(false, true);
      return true;
    } else {
      if(o['msg']){
        let str = o['msg'].replace(/<br\/>/g,"\n")
        wizNotice.error({
          message:'失败',
          description: (
            <div>
              <p style={{whiteSpace: "pre-line"}}>{str}</p>
            </div>
          ),
        })
      }else{
        wizNotice.error("导入数据出错，请联系相关人员")
      }
      return false;
    }
  }

  propsAndStateOnChange = {
    normalDealerImports: this._handldImport.bind(this),
  }


  _render() {
    let roleId = this.props.roleId;
    let infoProps = {
      title: '导入说明',
      text: [
        <Paragraph>1、从模版链接中下载模版文件</Paragraph>,
        <Paragraph>2、按照要求格式填写信息</Paragraph>,
        <Paragraph>3、当完成Excel文件的填写后，点击“上传文件”按钮上传此文件</Paragraph>,
      ]
    }
    let operateProps = {
      title: '正常经销商导入',
      template: {
        label: '模版下载',
        fileName: '模版.xlsx',
        href: constants.files.excel_normalDealerTemp,
      }

    }
    let submit = (file, fileData) => {
      let apiPath = 'normalDealer/import';
      this.doAction({
        path: apiPath,
        payload: {
          key: "import",
          apiParams: {
            fileData
          }
        }
      });
    }
    let { normalDealerLoading } = this.props;
    return (
      <WizSpin tip={'文件上传中'} spinning={normalDealerLoading}>
        <ExportExcel
          infoProps={infoProps}
          operateProps={operateProps}
          submit={submit}
        />
      </WizSpin>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  // return {};
  const { normalDealer } = state;
  const normalDealerImports = modelUtils.getModelEntity(normalDealer, 'import');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'normalDealer')
  return {
    normalDealerImports: normalDealerImports,
    ...load
  }
};

const options = { withRef: true };

export default connect(mapStateToProps,null, null, options)(NormalDealerImport);
